import { Box, Button, Typography } from "@mui/material";
import React, { useState } from "react";
import { useEffect } from "react";
import { removeTripFromProject } from "../../api/group";
import { getAllTrip } from "../../api/trip";
import notTrips from "../../assets/image/notTrips.png";
import EditEreaIcon from "../../assets/SVG/editEreaIcon";
import EditIcon from "../../assets/SVG/editIcon";
import FlagIcon from "../../assets/SVG/flagIcon";
import MapMarkerIcon from "../../assets/SVG/mapMarkerIcon";
import NoteAddIcon from "../../assets/SVG/noteAddIcon";
import TrashIcon from "../../assets/SVG/trashIcon";
import CreateTripPop from "./createTripPop";
import DeleteAlertModal from "./deleteAlertModal";

export default function TripsPage() {
  const [anchorEl, setAnchorEl] = useState();
  const [dataSelected, setDataSelected] = useState();
  const [dataTrips, setDataTrips] = useState();
  const [dataTripClick, setDataTripClick] = useState();
  const [deleteModal, setDeleteModal] = useState();
  useEffect(() => {
    getAllTrip()
      .then((x) => {
        setDataTrips(x);
      })
      .catch(() => {});
  }, []);

  const handleDelete = () => {
    if (dataTripClick) {
      removeTripFromProject(dataTripClick.projectId, dataTripClick.id)
        .then(() => {
          setDeleteModal(false);
          getAllTrip()
            .then((x) => {
              setDataTrips(x);
            })
            .catch(() => {});
        })
        .catch(() => {});
    }
  };

  return (
    <>
      <CreateTripPop
        // dataGroup={data}
        dataDef={dataTripClick}
        dataSelected={dataSelected}
        setAnchorEl={setAnchorEl}
        anchorEl={anchorEl}
        setDataTrips={setDataTrips}
      />
      <DeleteAlertModal
        handleDelete={handleDelete}
        open={deleteModal}
        setOpen={setDeleteModal}
      />
      <Typography sx={{ mt: "30px !important" }} className="title_GroupOnline">
        {"تاریخچه اردوها"}
      </Typography>
      <Box flexWrap={"wrap"} mt="50px" display="flex" gap="15px">
        {dataTrips?.map((x) => (
          <Box
            //   mt="50px"
            p="10px"
            bgcolor="#F5F9FF"
            borderRadius="12px"
            width="240px"
            height="170px"
            boxShadow={"0px 4px 4px 0px rgba(0, 0, 0, 0.25)"}
          >
            <Box
              sx={{
                overflow: "auto",
                height: "100%",
                px: "5px",
                direction: "ltr",
                "::-webkit-scrollbar-thumb": {
                  background: "#126E83",
                  // borderRadius: "10px"
                },
                "::-webkit-scrollbar-track": {
                  background: "#A7C9D1",
                  borderRadius: "10px",
                },
              }}
            >
              <Box sx={{ direction: "rtl" }}>
                <Box display="flex" justifyContent={"space-between"}>
                  <Typography
                    fontWeight="bold"
                    color="var(--emr-font)"
                    fontSize={"20px"}
                    mt="15px"
                  >
                    {x.name}
                  </Typography>
                  <Box display="flex" alignItems={"center"}>
                    <Box
                      sx={{
                        borderRadius: "50%",
                        minWidth: "40px",
                        height: "40px",
                        alignItems: "center",
                        cursor: "pointer",
                        display: "flex",
                        justifyContent: "center",
                        ":hover": { bgcolor: "#ededed" },
                      }}
                      onClick={(e) => {
                        setDataTripClick(x);
                        setAnchorEl(e.currentTarget);
                      }}
                    >
                      <EditIcon />
                    </Box>
                    {/* <Box
                      sx={{
                        borderRadius: "50%",
                        minWidth: "40px",
                        height: "40px",
                        alignItems: "center",
                        cursor: "pointer",
                        display: "flex",
                        justifyContent: "center",
                        ":hover": { bgcolor: "#ededed" },
                      }}
                      onClick={() => {
                        setDeleteModal(true);
                        setDataTripClick(x);
                      }}
                    >
                      <TrashIcon color="var(--emr-red)" />
                    </Box> */}
                  </Box>
                </Box>
                {x.startAt && (
                  <Typography
                    color="var(--emr-gray)"
                    //   fontSize={"16px"}
                    mt="10px"
                  >
                    {`${x.startAt?.split(" ", 1)[0]} - ${
                      x.endAt?.split(" ", 1)[0]
                    } `}
                  </Typography>
                )}
                {x.areas?.length >= 1 &&
                  x.areas?.map((item, index) => (
                    <Box
                      sx={{ cursor: "pointer" }}
                      mt={index === 0 ? "20px" : "15px"}
                      display={"flex"}
                    >
                      <MapMarkerIcon color={`var(--emr-${item.color})`} />
                      <Typography mr="8px" fontSize={"14px"} color="#6C6969">
                        {item.name}
                      </Typography>
                    </Box>
                  ))}
              </Box>
            </Box>
          </Box>
        ))}
      </Box>
      {dataTrips?.length === 0 && (
        <Box
          height="80%"
          display="flex"
          alignItems={"center"}
          justifyContent="center"
        >
          <img src={notTrips} />
        </Box>
      )}
    </>
  );
}
